import React from 'react';
import PropTypes from 'prop-types';
import download from '../../containers/function/download';

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex">
      <div className="flex filter-box">
        <h2 id="select-filter" className="container-filter-h2">
          {props.language.account.filterDriver.show}:{' '}
          {/*props.language.account.filterDriver.activeDriver*/}
          Asignaciones abiertas
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul>
              <li data-select="a" onClick={props.handleHomologation}>
                {props.language.account.filterDriver.activeDriver}
              </li>
              <li data-select="e" onClick={props.handleHomologation}>
                {props.language.account.filterDriver.allDriver}
              </li>
              <li data-select="b" onClick={props.handleHomologation}>
                {props.language.account.filterDriver.associatedDriver}
              </li>
              <li data-select="c" onClick={props.handleHomologation}>
                {props.language.account.filterDriver.pendingDriver}
              </li>
              <li data-select="d" onClick={props.handleHomologation}>
                {props.language.account.filterDriver.desactiveDriver}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div className="btn-group-allocator">
      {props.arrLength > 0 && (
        <button className="btn1" onClick={props.handleShowAlert}>
          Guardar
        </button>
      )}
      <button
        className={`${props.arrLength > 0 ? 'bg-gray' : 'bg-white'} btn2`}
        onClick={props.handleCancel}
      >
        Cancelar
      </button>
      <div className="box-form box-assignador">
        <ul className="buttom_menu">
          <li>
            {/*props.language.account.createDriver.create*/}
            Carga masiva
            <ul>
              <li>
                <a data-close="ok" onClick={props.handleModalUpdate}>
                  Importar Excel
                </a>
              </li>
              <li>
                <a data-close="ok" onClick={props.handleModalDownload}>
                  Descargar Plantilla
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/allocator/button.jsx